import { z } from 'zod'

export const documentWithDownloadUrlSchema = z.object({
  uuid: z.string().uuid(),
  url: z.string(),
})

export type TDocumentContent = z.infer<typeof documentWithDownloadUrlSchema>
